module.exports = __webpack_public_path__ + "img/solution--safe-patient-moving-and-handling.ff655d2e.jpg";